// The emboss line is the name embossed on a physical card. The card producer
// only accepts upper case ASCII letters, digits and spaces, which is what the
// server applies in app/helpers/emboss_line_helper.rb and enforces in
// app/validators/emboss_validator.rb - keep the three in sync.
import _ from 'lodash'

// Same limit as EmbossValidator::MAX_LENGTH. The fields of a product that
// embosses more, such as the commercial cards, say so with `data-max-length`.
export const EMBOSS_LINE_MAX_LENGTH = 24

// Spelled out the way the i18n transliteration rules in config/locales/de.yml
// do it, `deburr` on its own would turn them into a plain A/O/U.
const SUBSTITUTIONS = { Ä: 'AE', Ö: 'OE', Ü: 'UE' }
const SUBSTITUTION_PATTERN = /[ÄÖÜ]/g

// Character level conversion, safe to apply while the customer is typing: upper
// case the value, spell out the umlauts, drop the accents and replace anything
// else with a space. Neither trimmed nor truncated on purpose - while typing
// the surrounding spaces are what separates the first from the last name, and
// the callers that do care about the length need to see the full one.
export const embossCharacters = (value) => {
  const substituted = String(value ?? '')
    .toUpperCase()
    .replace(SUBSTITUTION_PATTERN, (char) => SUBSTITUTIONS[char])

  return (
    _.deburr(substituted)
      // `deburr` maps a few ligatures to a mixed case pair, e.g. Æ -> Ae.
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, ' ')
  )
}

// The value as the server would store it, used once the field is left. Fields
// with less room than the default pass their own `maxLength`.
export const embossLine = (value, maxLength = EMBOSS_LINE_MAX_LENGTH) => {
  return embossCharacters(value)
    .trim()
    .slice(0, maxLength)
}
